export default __webpack_public_path__ + "static/moon-xs-65be3d18bf6ec206c9b364e0003c0610.webp";